import { z } from 'zod'
import { TicketValidityPeriod } from '~library/enums'
import {
  managerBenefitFileSchema,
  managerBenefitCommonSchema,
  dateValueSchema
} from '~library/models'
import { fileDescriptionSchema } from './file-description'

export const managerBenefitGetDetailSchema = z
  .object({
    /** 熱門 */
    popular: z.boolean(),
    /** 限時 */
    flashSale: z.boolean(),
    /** 限量 */
    limitedEdition: z.boolean(),
    /** 售罄 */
    soldOut: z.boolean(),
    /** 原始點數 */
    originalPoint: z.number(),
    /** 點數 */
    point: z.number(),
    /** 用效期[天] */
    validityPeriod: z.union([
      z.nativeEnum(TicketValidityPeriod),
      // 購票優惠碼會回 '0'
      z.literal('0'),
      z.null()
    ]),
    /** 使用說明與注意事項[英文] */
    englishDesc: z.string(),
    /** 檔案 */
    file: z.array(managerBenefitFileSchema),
    /** 購物車數量 */
    shoppingCartQuantity: z.number(),
    /** 庫存數量 */
    quantity: z.number(),
    /** 使用起始時間 */
    useStartTime: dateValueSchema,
    /** 使用截止時間 */
    useEndTime: dateValueSchema
  })
  .merge(managerBenefitCommonSchema)
  .merge(fileDescriptionSchema)

export interface ManagerBenefitGetDetail extends z.infer<
  typeof managerBenefitGetDetailSchema
> {}
